import { FETCH_ASSET } from "../../actions/types";

const INITIAL_STATE = {
  description: "",
  timezone: "",
  bess_capacity_kwh: 0,
  bess_supplier: "",
  bess_technical_contact: {
    email: "",
    tel: ""
  },

  customer_commercial_contact: {
    email: "",
    tel: "",
    name: ""
  },

  customer_technical_contact: {
    email: "",
    tel: "",
    name: ""
  },

  peak_shaving_type: "",
  peak_shaving_generic: {
    p_ref_kw: 0,
    p_max_kw: 0
  },
  peak_shaving_atypical: {
    target_dev: 0,
    deviation: 0,
    p_max_on_peak_kw: 0
  }
};

const assetReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ASSET:
      return payload.data.asset;
    default:
      return state;
  }
};

export default assetReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/asset_reducer.js